import { NavButton } from "./NavButton";
import { NavItem } from "@/config/navigation";
import { cn } from "@/lib/utils";

interface NavSectionProps {
  title: string;
  items: readonly NavItem[];
  setIsMenuOpen: (value: boolean) => void;
  currentPath: string;
  isCollapsed: boolean;
  isMobile?: boolean;
  badgesByHref?: Record<string, number>;
  isPaid?: boolean;
  subscriptionLoading?: boolean;
}

/**
 * Nav Section.
 */
export function NavSection({
  title,
  items,
  setIsMenuOpen,
  isCollapsed,
  isMobile = false,
  badgesByHref,
  isPaid,
  subscriptionLoading,
}: Readonly<NavSectionProps>) {
  return (
    <div className={cn("py-2.5", isMobile ? "px-6" : "px-4")}>
      {title && !isCollapsed && (
        <p
          className={cn(
            "mb-2 text-[10px] font-semibold text-primary uppercase tracking-wider",
            isMobile && "text-xs"
          )}
        >
          {title}
        </p>
      )}
      <div className={cn(isMobile ? "space-y-2.5" : "space-y-2")}>
        {items.map((item) => (
          <NavButton
            key={item.href}
            href={item.href}
            icon={item.icon}
            label={item.title}
            isCollapsed={isCollapsed}
            requiresPremium={item.requiresPremium}
            onClick={() => setIsMenuOpen(false)}
            isMobile={isMobile}
            badgeCount={badgesByHref?.[item.href]}
            submenu={item.submenu}
            isPaid={isPaid}
            subscriptionLoading={subscriptionLoading}
          />
        ))}
      </div>
    </div>
  );
}
